import { PostApplyFlowSteps } from '@components/app/ApplySuccessPage/PostApplyPrompt/Steps'
import { SurveyQuestionsConditions } from '@components/hooks/PatientTrialApplySurveyProvider/SurveyQuestionsConditions'
import { SurveyQuestionsDemographics } from '@components/hooks/PatientTrialApplySurveyProvider/SurveyQuestionsDemographics'
import { SurveyQuestionsLocations } from '@components/hooks/PatientTrialApplySurveyProvider/SurveyQuestionsLocations'
import { TrialApplyFlowInitSteps } from './TrialApplyFlowInitSteps'
import type { TrialApplyFlowStep } from './TrialApplyFlowStepTypes'

export const StageSegmentMapping = {
  applyRecommendations: 3,
  applySuccess: 4,
  trialApply: 1,
}
export const SurveyCategorySegmentMapping = {
  conditions: 2,
  demographics: 2,
  locations: 2,
  postscreener: 3,
  prescreener: 3,
}

const InitSteps: TrialApplyFlowStep[] = TrialApplyFlowInitSteps.map((step) => ({
  stepId: step.stepId,
}))

const ApplySuccessSteps: TrialApplyFlowStep[] = PostApplyFlowSteps.map(
  (step) => ({
    stepId: step.stepId,
  }),
)

const DemographicsSteps: TrialApplyFlowStep[] = SurveyQuestionsDemographics.map(
  (step) => ({
    category: 'demographics',
    stepId: step.id,
  }),
)
const LocationsSteps: TrialApplyFlowStep[] = SurveyQuestionsLocations.map(
  (step) => ({
    category: 'locations',
    stepId: step.id,
  }),
)
const ConditionsSteps: TrialApplyFlowStep[] = SurveyQuestionsConditions.map(
  (step) => ({
    category: 'conditions',
    stepId: step.id,
  }),
)

const ApplySurveySteps: TrialApplyFlowStep[] = [
  ...DemographicsSteps,
  ...LocationsSteps,
  ...ConditionsSteps,
]

export const TrialApplyFlowSteps = {
  applySuccess: ApplySuccessSteps,
  applySurvey: ApplySurveySteps,
  trialApply: InitSteps,
}
